// src/redux/features/userSearchSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { fetchGlobalSearchResults } from './searchActions';

// Thunk: Search users inside a group
const searchSlice = createSlice({
  name: 'search',
  initialState: {
    users: [],
    stocks: [],
    loading: false,
    error: null,
    currentQuery: '',
  },
  reducers: {
    clearSearchResults: (state) => {
      state.users = [];
      state.stocks = [];
      state.loading = false;
      state.error = null;
    },
    setCurrentQuery: (state, action) => {
      state.currentQuery = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGlobalSearchResults.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGlobalSearchResults.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.users;
        state.stocks = action.payload.stocks;
        state.error = null;
      })
      .addCase(fetchGlobalSearchResults.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearSearchResults, setCurrentQuery } = searchSlice.actions;
export default searchSlice.reducer;
